var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"zoomManager",staticClass:"the-zoom-manager",class:{
    'the-zoom-manager--active': _vm.isZoomActive,
    'the-zoom-manager--use-transitions': _vm.useZoomTransitions,
  },style:({ transform: _vm.transformScale })},[_c('div',{ref:"imageWrapper",staticClass:"the-zoom-manager__position",class:{
      'the-zoom-manager__position--use-transitions': _vm.usePositionTransitions,
    },style:({ transform: _vm.transformPosition })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }